interface ILmsSectionProps {
  title: string;
  placeholderText: string;
}

/** Умный раздел LMS. Пока отображает состояние раздела до подключения бизнес-логики. */
export function LmsSection({ title, placeholderText }: ILmsSectionProps) {
  return (
    <div className="telegram-chat-list__placeholder">
      <span className="telegram-chat-list__pulse" aria-hidden="true" />
      <strong>{title}</strong>
      <p>{placeholderText}</p>
    </div>
  );
}
